module.exports = __webpack_public_path__ + "img/high-furniture.45c7003.svg";